export const validEmailRegex =
  /^([A-Za-z0-9]+([^<>()[\]\\.,;:\s@"]*(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const validUrlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9][-a-zA-Z0-9]*\.)+[a-zA-Z]{2,63}(\/.*)?$/;
export const onlyDigitsRegex = /^-?[0-9]{1,}$/;
export const onlyDigitsWithDecimalRegex = /^-?[0-9]*\.?[0-9]{1,2}$/;
export const phoneNumberRegex = /^\+[0-9]*$/;
export const nameKeyRegex = /[\s\-–,‚'._/()[\]{}&$%:!’°*®™©√]/g;
export const alphaNumeric = /^[A-Za-z0-9]*$/;
export const alphaNumericWithSpace = /^[A-Za-z0-9\s]*$/;
export const startsWithDomainRegex = /^([a-zA-Z0-9]+[.-]?)+$/;
export const endsWithDomainRegex = /^([.-]?[a-zA-Z0-9]+)*[.]{1}[a-zA-Z0-9]{2,}$/;
export const exactMatchDomainRegex = /^([a-zA-Z0-9]+[.-]?)+([a-zA-Z0-9]+[.]{1}[a-zA-Z0-9]{2,})+$/;
export const containsDomainRegex = /^([.-]?[a-zA-Z0-9]+[.-]?)+$/;
export const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#*!$%^&+=])(?=\S+$).{8,20}$/;
export const containsNumber = /\d/;
export const containsUppercase = /[A-Z]/;
export const containsLowercase = /[a-z]/;
export const containsSpecialCase = /[@#*!$%^&+=]/;
export const containsSpace = / /;
export const containsHtmlTags = /<[a-z][\s\S]*>/i;
export const htmlTagsRegex = /<[^>]*>/g;
export const htmlColorRegex = /^#[0-9a-fA-F]{6}$/;
export const nameInitialsRegex = /[~`!@#$%^&*()\-_+=/{}[\]|\\;:'"<,.>?]/g;
export const validWordRegex = /^\w+$/;
export const purchaseOrderIdentifierRegex = /^po_[0-9]{9}$/;
export const transactionIdentifierRegex = /^tr_[0-9]{9}$/;
export const containsNoSpace = /^\S*$/;
export const fileNameRegex = /[^A-Za-z0-9.-]+/g;
